import React, { Component } from "react";
import { Badge, Button, Card, Checkbox, Col, Divider, Icon, List, message, Modal, Row, Tabs, Radio } from 'antd';
import PropTypes from 'prop-types';
import styles from '../index.css'
import default_bed from '../../../styles/images/g-bed.jpg'
import default_bed_l from '../../../styles/images/bed-g.jpg'
import selected_bed from '../../../styles/images/b-bed.jpg'
import selected_bed_1 from '../../../styles/images/bed-b.jpg'
import cur_bed from '../../../styles/images/bed-y.jpg'
import NHFetch from "../../../utils/NHFetch";
import { getLoginUser } from "../../../utils/NHCore";
import { Scrollbars } from 'react-custom-scrollbars';
import getSize from '../../../utils/getSize';
import { NHModal, NHConfirm } from '../../common/NHModal';

const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const TabPane = Tabs.TabPane;

const basicUrl = 'api/zhxg-gyxt/cwfp/';

/**
 * @author weishihuai
 * @date 2018/6/28
 * @time 9:06
 * @Description: 迎新现场-宿舍分配
 */
class Ssfp extends React.Component {
    constructor() {
        super();
        this.state = {
            visible: false,             //选择床位Modal是否显示
            editable: undefined,        //是否可编辑
            cwsList: [],                //床位数
            sfbzList: [],               //收费标准
            xqList: [],                 //校区信息
            fjxxList: [],               //房间信息
            currentClickFjxx: {},       //当前选择床位
            currentClickCwh: "",        //当前床位号
            currentClickCwPkid: "",     //当前床位信息ID
            xsssruYwxx: {},             //学生宿舍入住业务信息
            param: {},                  //过滤条件
            currentXqid: "",            //当前校区ID
            scrollHeight: 200,           //默认滚动高度
            zdblLoading: false,
            loading: false,
            sfbz: "",                   //收费标准选中值
            sfmy: "",                   //是否满员选中值
        }
    }

    componentWillMount() {
        let that = this;
        this.setState({ scrollHeight: getSize().windowH - 206 });
        window.onresize = function () {
            that.setState({
                scrollHeight: getSize().windowH - 206,
            })
        }
    }

    // componentDidMount() {
    //     let { xsid, xqid, xbm } = this.props.studentData;
    //     if (xsid) {
    //         //加载收费标准、床位数信息
    //         this.getSfbzAndCwsInfo(xsid, xqid, xbm);
    //         this.getXsssrzYwxxByXsid(xsid);

    //         //如果学生校区ID不为空,则只加载本校区宿舍信息
    //         if (xqid) {
    //             this.setState({
    //                 currentXqid: xqid
    //             });
    //             this.getFjxxList({
    //                 cws: "",
    //                 sfbz: "",
    //                 xsid: xsid,
    //                 xqid: xqid,
    //                 xbm: xbm
    //             });
    //         }
    //     }
    // }

    componentWillReceiveProps(nextProps) {
        const newStudentData = nextProps.studentData;
        const oldStudentData = this.props.studentData;
        const studentChange = oldStudentData.xsid !== newStudentData.xsid;//搜索不同的学生时让init方法的请求更新
        //环节办理状态
        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            if (hjblztData.hjdm === 'GD003') {
                const isEditable = this.state.editable;
                const editable = hjblztData.blzt !== '1';
                this.setState({ editable: editable }, () => {
                    this.init(studentChange, nextProps, isEditable, editable);
                });
                /* 想不明白hjblztData.hjdm都能等于GD003了干嘛还要判断hjblztData是否存在？===>这是我把你注释的原因 */
                // if (hjblztData) {
                //     let editable = hjblztData.blzt !== '1';
                //     this.setState({ editable: editable }, () => {
                //         this.init(nextProps, isEditable, editable);
                //     });
                // } else {
                //     this.setState({ editable: true }, () => {
                //         this.init(nextProps, isEditable, editable);
                //     });
                // }
            }
        }
    }

    init = (studentChange, nextProps, isEditable, editable) => {
        //学生数据
        if ('studentData' in nextProps && 'hjblztData' in nextProps) {
            const newStudentData = nextProps.studentData;
            const oldStudentData = this.props.studentData;
            //避免多次请求
            if ((Object.keys(newStudentData).length !== 0 && Object.keys(oldStudentData).length === 0) ||
                (Object.keys(newStudentData).length !== 0 && Object.keys(oldStudentData).length !== 0
                    && studentChange || isEditable == undefined)) {
                const { xsid, xqid, xbm } = newStudentData;
                console.log('测试:进来没？--->应该进来了')
                if (xsid) {
                    if (editable) {
                        //加载收费标准、床位数信息
                        this.getSfbzAndCwsInfo(xsid, xqid, xbm);
                        //如果学生校区ID不为空只加载本校区宿舍信息
                        if (xqid) {
                            this.setState({
                                currentXqid: xqid
                            });
                            this.getFjxxList({
                                cws: "",
                                sfbz: "",
                                xsid: xsid,
                                xqid: xqid,
                                xbm: xbm
                            });
                        }
                    } else {
                        this.getXsssrzYwxxByXsid(xsid);
                    }
                }
            }
        }
    }

    //获取收费标准、床位信息等
    getSfbzAndCwsInfo = (xsid, xqid, xbm) => {
        NHFetch(basicUrl + "getYxxcSfbzAndSslxInfo", 'GET', { xqid: xqid ? xqid : "", xsid: xsid, xbm: xbm })
            .then(res => {
                if (res) {
                    const data = res.data;
                    this.setState({
                        cwsList: data.cwsList,
                        sfbzList: data.sfbzList,
                        xqList: data.xqList
                    });

                    //如果学生无校区信息,默认加载第一个Tab校区的宿舍信息
                    if (!xqid) {
                        this.setState({
                            currentXqid: data.xqList[0].XQID
                        });
                        this.getFjxxList({
                            cws: "",
                            sfbz: "",
                            xsid: xsid,
                            xqid: data.xqList[0].XQID,
                            xbm: xbm
                        });
                    }
                }
            });
    };

    //获取宿舍房间信息
    getFjxxList = (param) => {
        NHFetch(basicUrl + "getSsfpFjxxList", 'GET', param)
            .then(res => {
                if (res) {
                    this.setState({
                        fjxxList: res.data
                    });
                }
            });
    };

    //显示选择床位弹窗
    showModal = (item) => {
        const { cwxxVOs } = item;
        let availableSelectArr = [];
        for (let item of cwxxVOs) {
            availableSelectArr.push(item.availableSelect);
        }

        if (availableSelectArr.indexOf(true) === -1) {
            message.warning("抱歉，该房间已满员，请选择其他房间！");
            return;
        }

        this.setState({
            currentClickFjxx: item,
            visible: true
        });
    };

    //隐藏选择床位弹窗
    hideModal = () => {
        this.setState({
            visible: false,
            currentClickCwh: "",
            currentClickCwPkid: ""
        });
    };

    cwfpSubmit = (xsid, currentClickCwPkid, xqid, xbm) => {
        let params = { xsid: xsid, cwid: currentClickCwPkid };
        NHFetch(basicUrl + 'confirmCwxx', 'POST', params)
            .then(res => {
                if (res) {
                    if (res.data) {
                        message.success("分配成功！请尽快确认办理");
                        this.setState({
                            visible: false,
                            currentClickCwh: "",
                            currentClickCwPkid: ""
                        });
                        this.getFjxxList({
                            cws: "",
                            sfbz: "",
                            xsid: xsid,
                            xqid: xqid ? xqid : this.state.currentXqid ? this.state.currentXqid : this.state.xqList[0].XQID,
                            xbm: xbm
                        });
                    }
                }
            })
    };

    //确认床位分配
    confirmCwfpxx = () => {
        const { currentClickCwPkid } = this.state;
        const { xsid, xqid, xbm } = this.props.studentData;
        if (!currentClickCwPkid) {
            message.warning("请先选择一个床位！");
            return;
        }

        //检查该床位是否被其他学生抢占(防并发的情况下同一个床位被其他人重复选择)
        NHFetch(basicUrl + 'checkCwIsPermitSelect', 'GET', { cwid: currentClickCwPkid, xsid: xsid })
            .then(res => {
                if (res) {
                    if (res.data === 0) {
                        message.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                        return;
                    } else {
                        //确认床位信息
                        this.cwfpSubmit(xsid, currentClickCwPkid, xqid, xbm);
                    }
                }
            });
    };

    //查询学生宿舍入住信息
    getXsssrzYwxxByXsid = (xsid) => {
        NHFetch(basicUrl + 'getXsssrzYwxxByXsid', 'GET', { xsid: xsid })
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        xsssruYwxx: res.data
                    });
                }
            });
    };

    updateSsfpRzInfoToYrz = (params, xsid) => {

        NHFetch(basicUrl + 'updateSsfpRzInfoToYrz', 'POST', params)
            .then(res => {
                if (res) {
                    if (res.data === 1) {
                        message.success('环节办理成功！');
                        //回调
                        this.getXsssrzYwxxByXsid(xsid);
                        this.setState({
                            editable: false
                        });

                        //办理完成回调
                        const onFinish = this.props.onFinish;
                        if (onFinish) {
                            onFinish('submit');
                        }
                    } else {
                        message.error("环节办理失败，请重试！");
                    }
                    this.setState({ loading: false })
                } else {
                    message.error("环节办理失败，请重试！");
                    this.setState({ loading: false })
                }
            }).catch(() => {
                //message.error("环节办理失败，请重试！");
                this.setState({ loading: false })
            });
    };

    //确定办理提交
    handleSubmit = () => {
        const { xsid } = this.props.studentData;
        const { pkid } = this.props.hjblztData;
        let flag = false;
        if (!xsid) {
            message.error("环节办理失败,请先查询学生信息！");
            return;
        }
        this.setState({ loading: true });
        NHFetch(basicUrl + 'getXsssrzYwxxByXsid', 'GET', { xsid: xsid })
            .then(res => {
                if (res) {
                    if (!res.data) {
                        flag = true;
                        message.warning("环节办理失败,请先选择要住宿的床位！");
                        this.setState({ loading: false })
                        return false;
                    } else {
                        let userId = getLoginUser() ? getLoginUser().userId : '';
                        let params = { xsid: xsid, lchjid: pkid, yhbh: userId };
                        this.updateSsfpRzInfoToYrz(params, xsid);
                        this.setState({ loading: false })
                    }
                }
                this.setState({ loading: false });
            }).catch((ress) => {
                this.setState({ loading: false });
            });
    };

    //取消办理提交
    handleCancel = () => {
        const { pkid } = this.props.hjblztData;
        const { xsid, xqid, xbm } = this.props.studentData;
        let params = { xsid: xsid, lchjid: pkid };

        NHConfirm("是否确定取消办理？", () => {
            this.setState({ loading: true });
            NHFetch(basicUrl + 'clearSsfpRzInfoByXsid', 'POST', params)
                .then(res => {
                    if (res && res.data === 1) {
                        message.success('环节办理取消成功！');
                        this.getSfbzAndCwsInfo(xsid, xqid, xbm);
                        this.getFjxxList({
                            cws: "",
                            sfbz: "",
                            xsid: xsid,
                            xqid: xqid ? xqid : this.state.currentXqid ? this.state.currentXqid : this.state.xqList[0].XQID,
                            xbm: xbm
                        });

                        this.setState({
                            editable: true,
                            xsssruYwxx: {}
                        });

                        //取消办理完成回调
                        const onFinish = this.props.onFinish;
                        if (onFinish) {
                            onFinish('cancel');
                        }
                    } else {
                        message.error('环节办理取消失败，请重试！');
                    }
                    this.setState({ loading: false });
                }).catch(() => {
                    message.error("环节办理取消失败，请重试！");
                    this.setState({ loading: false });
                });
        }, "warn");
    };

    //自动入住事件
    autoSelectCwListener = (item) => {
        const { xsid, xqid, xbm } = this.props.studentData;
        const { cwxxVOs, title } = item;
        let availableSelectArr = [], availSelectCwPkId = "", text = "";
        for (let item of cwxxVOs) {
            availableSelectArr.push(item.availableSelect);
        }

        if (availableSelectArr.indexOf(true) === -1) {
            message.warning("抱歉，该房间已满员，请选择其他房间！");
            return;
        }

        //自动分配该房间的某个空床位
        for (let item of cwxxVOs) {
            if (item.availableSelect === true) {
                availSelectCwPkId = item.pkid;
                text = title + "-" + item.cwh;
                break;
            }
        }

        NHFetch(basicUrl + 'checkCwIsPermitSelect', 'GET', { cwid: availSelectCwPkId, xsid: xsid })
            .then(res => {
                if (res) {
                    if (res.data === 0) {
                        message.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                        return;
                    } else {
                        // 确认床位信息
                        NHFetch(basicUrl + 'confirmCwxx', 'POST', { xsid: xsid, cwid: availSelectCwPkId })
                            .then(res => {
                                if (res) {
                                    if (res.data) {
                                        message.success("分配成功，分配宿舍为 " + text + ", 请尽快确认办理！");
                                        this.getFjxxList({
                                            cws: "",
                                            sfbz: "",
                                            xsid: xsid,
                                            xqid: xqid ? xqid : this.state.currentXqid ? this.state.currentXqid : this.state.xqList[0].XQID,
                                            xbm: xbm
                                        });
                                    }
                                } else {
                                    message.error("分配失败，请稍后重试！");
                                }
                            })
                    }
                }
            });
    };

    //自动办理分配
    handleAutoDistributeListener = () => {
        const { xsid, xqid, xbm } = this.props.studentData;
        const { pkid } = this.props.hjblztData;
        let userId = getLoginUser() ? getLoginUser().userId : '';

        if (!xsid) {
            message.warning("自动办理失败,请先选择一个学生！");
            return;
        }

        //自动分配宿舍
        const { param } = this.state;
        let params = {
            cws: param.cws || "",
            sfbz: param.sfbz || "",
            xsid: xsid,
            xqid: xqid ? xqid : this.state.currentXqid ? this.state.currentXqid : this.state.xqList[0].XQID,
            xbm: xbm,
            lchjid: pkid,
            yhbh: userId
        };
        this.setState({ zdblLoading: true });
        NHFetch(basicUrl + "autoDistributeSscwxx", 'POST', params).then(res => {
            if (res) {
                if (res.data === 1) {
                    let text = "";
                    NHFetch(basicUrl + 'getXsssrzYwxxByXsid', 'GET', { xsid: xsid })
                        .then(res => {
                            if (res && res.data) {
                                let data = res.data;
                                this.setState({
                                    xsssruYwxx: data
                                });
                                text = data.ldmc + "-" + data.fj + "-" + data.cwh + "号床位";
                                message.success("自动办理成功,分配宿舍为 " + text + "！");

                                // this.getFjxxList({
                                //     cws: "",
                                //     sfbz: "",
                                //     xsid: xsid,
                                //     xqid: xqid ? xqid : this.state.currentXqid ? this.state.currentXqid : this.state.xqList[0].XQID,
                                //     xbm: xbm
                                // });

                                this.setState({
                                    editable: false
                                });

                                //办理完成回调
                                const onFinish = this.props.onFinish;
                                if (onFinish) {
                                    onFinish('submit');
                                }
                            } else {
                                message.error("自动办理失败,请稍后重试！");
                            }
                        });
                }
                this.setState({ zdblLoading: false });
            } else {
                message.error("自动办理失败,请稍后重试！");
                this.setState({ zdblLoading: false });
            }
        }).catch(() => {
            message.error("自动办理失败,请稍后重试！");
            this.setState({ zdblLoading: false });
        });
    };

    //收费标准onChange事件
    onSfbzChangeListener = (checkedValues) => {
        const { param, currentXqid, sfmy } = this.state;
        const { xsid, xbm } = this.props.studentData;
        param.sfbz = checkedValues.length > 0 ? checkedValues.join(",") : "";
        param.xsid = xsid;
        param.xqid = currentXqid ? currentXqid : this.state.xqList[0].XQID;
        param.xbm = xbm;
        param.sfmy = sfmy
        this.setState({
            sfbz: checkedValues.length > 0 ? checkedValues.join(",") : ""
        });
        this.getFjxxList(param);
    };

    //宿舍类型onChange事件
    onCwsChange = (checkedValues) => {
        const { param, currentXqid } = this.state;
        const { xsid, xbm } = this.props.studentData;
        param.cws = checkedValues.length > 0 ? checkedValues.join(",") : "";
        param.xsid = xsid;
        param.xbm = xbm;
        param.xqid = currentXqid ? currentXqid : this.state.xqList[0].XQID;
        this.getFjxxList(param);
    };

    //是否满员onChange事件
    onSfmyChangeListener = (e) => {
        const { param, currentXqid, sfbz } = this.state;
        const { xsid, xbm } = this.props.studentData;
        param.sfmy = e.target.value;
        param.xsid = xsid;
        param.xqid = currentXqid ? currentXqid : this.state.xqList[0].XQID;
        param.xbm = xbm;
        param.sfbz = sfbz
        this.setState({
            sfmy: e.target.value
        });
        this.getFjxxList(param);
    };

    //选择床位事件
    selectCwClickListener = (cwxx) => {
        this.setState({
            currentClickCwh: cwxx.cwh,
            currentClickCwPkid: cwxx.pkid
        });
    };

    //tab切换事件
    tabChangeListener = (activeKey) => {
        const { xsid, xbm } = this.props.studentData;
        const { cws, sfbz } = this.state.param;
        this.setState({
            currentXqid: activeKey
        });
        //加载房间信息
        this.getFjxxList({
            cws: cws || "",
            sfbz: sfbz || "",
            xsid: xsid,
            xqid: activeKey,
            xbm: xbm
        });
    };

    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

    //上一步
    handleLast = () => {
        const { onLast } = this.props;
        if (onLast) {
            onLast();
        }
    };

    //下一步
    handleNext = () => {
        const { onNext } = this.props;
        if (onNext) {
            onNext();
        }
    };

    //获取ListItem项
    getListItem = (fjxxList) => {
        return <List
            locale={{ emptyText: '暂无匹配的宿舍信息！' }}
            grid={{ gutter: 15, xxl: 5, xl: 4, lg: 3, md: 2, sm: 1, xs: 1 }}
            dataSource={fjxxList}
            renderItem={item => (
                <List.Item>
                    <Card
                        hoverable
                        actions={[<a href="javascript:;"
                            onClick={this.autoSelectCwListener.bind(this, item)}>自动入住</a>,
                        <a href="javascript:;"
                            onClick={this.showModal.bind(this, item)}>选择床位</a>]}>
                        <Card.Meta
                            title={<div><Badge
                                status="processing" />{item.title}<span
                                    style={{
                                        float: 'right',
                                        fontSize: 14,
                                        verticalAlign: 'middle'
                                    }}><a
                                        href="javascript:;">{item.select}</a> / {item.total}</span>
                            </div>}
                            description={(
                                <div style={{
                                    textAlign: 'center',
                                    height: 70
                                }}>
                                    {
                                        item.cwxxVOs.map((cwxx, index) => {
                                            return (
                                                <img key={index}
                                                    src={cwxx.currentXsSelected ? cur_bed : cwxx.availableSelect ? default_bed : selected_bed} />
                                            )
                                        })
                                    }
                                </div>
                            )}
                        />
                    </Card>
                </List.Item>
            )}
        />
    };

    render() {
        const { editable, cwsList, sfbzList, xqList, fjxxList, currentClickFjxx, currentClickCwh, xsssruYwxx, scrollHeight, currentXqid, loading, zdblLoading } = this.state;
        const { xsid } = this.props.studentData;
        const { lchjData = {}, hasLast, hasNext } = this.props;
        let activeKey = currentXqid || (xqList[0] && xqList[0].XQID);

        const { sfdybdd = '0' } = lchjData; //是否打印报到单

        let fsmyList = [{ "label": "未满", "value": "0" }, { "label": "满员", "value": "1" }]

        return (
            <div>
                <Card type="inner" title="宿舍入住业务信息">
                    {
                        !xsid ? <div /> : editable ?
                            <div>
                                <div>收费标准：<CheckboxGroup options={sfbzList} onChange={this.onSfbzChangeListener} /></div>
                                <div>是否满员：<RadioGroup options={fsmyList} defaultValue={'0'} onChange={this.onSfmyChangeListener} /></div>
                                {/* <div style={{ marginTop: 10 }}>宿舍类型：<CheckboxGroup options={cwsList}
                                    onChange={this.onCwsChange} /></div> */}
                                <Tabs defaultActiveKey="0" activeKey={activeKey} onChange={this.tabChangeListener}>
                                    {
                                        xqList.map((xq) => {
                                            return (
                                                <TabPane tab={xq.XQMC} key={xq.XQID}>
                                                    <div style={{ textAlign: 'center', marginBottom: 10 }}>
                                                        <img src={default_bed} /> 可选择&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <img src={selected_bed} /> 不可选&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <img src={cur_bed} style={{ width: 20, height: 20 }} /> 已选择
                                                    </div>
                                                    {fjxxList.length > 20 ?
                                                        <Scrollbars autoHide
                                                            style={{ width: '100%', height: scrollHeight }}>
                                                            {this.getListItem(fjxxList)}
                                                        </Scrollbars> :
                                                        this.getListItem(fjxxList)
                                                    }
                                                </TabPane>
                                            );
                                        })
                                    }
                                </Tabs>
                                <Modal
                                    title=""
                                    width={300}
                                    closable={false}
                                    visible={this.state.visible}
                                    style={{ textAlign: 'center' }}
                                    okText="确认"
                                    cancelText="取消"
                                    onOk={this.confirmCwfpxx}
                                    onCancel={this.hideModal}
                                >
                                    <h3 style={{ fontWeight: 700 }}><Icon type="exclamation-circle" style={{
                                        color: '#F4AE12',
                                        fontSize: 16,
                                        marginRight: 10
                                    }} />确定选择{currentClickFjxx.title}房间的下列床位？</h3>
                                    {currentClickCwh &&
                                        <a href="javascript:;">{currentClickCwh > 9 ? currentClickCwh + "床" : "0" + currentClickCwh + "床"}</a>}
                                    <p style={{ margin: '0 0 10px' }}>{currentClickFjxx.ysje + "元/年"}</p>
                                    <div className={styles.modal_content}>
                                        {
                                            currentClickFjxx.cwxxVOs && currentClickFjxx.cwxxVOs.map((cwxx, index) => {
                                                return (
                                                    <span key={index}
                                                        style={{ cursor: cwxx.availableSelect ? "pointer" : "" }}
                                                        onClick={cwxx.availableSelect ? this.selectCwClickListener.bind(this, cwxx) : ""}>
                                                        <img
                                                            src={cwxx.cwh === currentClickCwh ? cur_bed : cwxx.currentXsSelected ? cur_bed : cwxx.availableSelect ? default_bed_l : selected_bed_1} />
                                                        {currentClickFjxx.cwxxVOs.length > 9 ? `${cwxx.cwh}床` : `0${cwxx.cwh}床`}
                                                    </span>
                                                );
                                            })
                                        }
                                    </div>
                                </Modal>
                            </div> :
                            <Row>
                                <Col span={8}>
                                    <p>校区：{xsssruYwxx.xqmc || ""}</p>
                                    <p>楼层：{xsssruYwxx.lcmc || ""}</p>
                                    <p>床位号：{xsssruYwxx.cwh || ""}</p>
                                </Col>
                                <Col span={16}>
                                    <p>楼栋：{xsssruYwxx.ldmc || ""}</p>
                                    <p>房间号：{xsssruYwxx.fj || ""}</p>
                                    <p>收费标准：{xsssruYwxx.ysje ? (xsssruYwxx.ysje + "元/年") : ""}</p>
                                </Col>
                            </Row>
                    }
                </Card>
                <Divider style={{ margin: '40px 0 24px' }} />
                {editable ? <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button> :
                    <Button type="primary" onClick={this.handleCancel} loading={loading}>取消办理</Button>}

                {
                    editable && <Button type="primary" style={{ marginLeft: 10 }} onClick={this.handleAutoDistributeListener} loading={zdblLoading}>自动办理分配</Button>
                }
                {
                    sfdybdd == '1' ? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                {
                    hasLast && <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button>
                }
                {
                    hasNext && <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button>
                }
            </div>
        )
    }
}

Ssfp.propTypes = {
    studentData: PropTypes.object,  //学生信息
    hjblztData: PropTypes.object,   //环节办理状态数据
    hjywxData: PropTypes.array,     //环节业务项数据
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool,        //是否有上一个环节
    hasNext: PropTypes.bool,        //是否有下一个环节
    onLast: PropTypes.func,         //上一步操作回调
    onNext: PropTypes.func,         //下一步操作回调
    onFinish: PropTypes.func,       //环节办理完成回调
    onPrint: PropTypes.func, //打印报到单
};

export default Ssfp;


// WEBPACK FOOTER //
// ./components/yxxc/steps/ssfp.js